/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { borderRadius, gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const FilterContainer = styled.div({
  margin: `0 0 ${gridSize() * 2}px 0`,
});

export const BranchActionsWrapper = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
});

export const BranchPaginationWrapper = styled.div({
  '& > div': {
    marginTop: `${gridSize() * 4}px`,
    marginBottom: `${gridSize() * 8}px`,
  },
});

// Apply 32px margin top to all but the first child within the wrapper
export const CommentThreadWrapper = styled.div({
  border: `1px solid ${token('color.border')}`,
  borderRadius: `${borderRadius()}px`,
  flex: 'auto',
  margin: `-${gridSize()}px`,
  padding: `${gridSize()}px`,
  maxWidth: '960px',
  '& > * + *': {
    marginTop: token('space.400'),
  },
});
